/* eslint-disable require-jsdoc */
export class Brief {
    constructor() {
        this.audience = "";
        this.shortTermPainPoints = "";
        this.longTermPainPoints = "";
        this.bigPromise = "";
        this.existingSolutions = "";
        this.newClaim = "";
        this.paradoxicalQuestion = "";
        this.metaphor = "";
        this.boldClaim = "";
        this.productDetails = "";
        this.discoveryStory = "";
        this.headlineIdeas = "";
        this.upsellIdeas = "";
    }
}
